import React from 'react'

export default function SmartviewTextGroup ({ children, className = '', highlight, highlightSize = 'default' }) {
  const classNames = [
    'smartview-text-group',
    'group',
    'space-y-6',
    className
  ]

  const sizes = {
    default: 'highlight-size-default',
    card: 'highlight-size-card'
  }

  if (highlight) {
    classNames.push('smartview-text-group--highlight ' + sizes[highlightSize])
  }

  return (
    <div className={classNames.join(' ')}>
      {children}
    </div>
  )
}
